/**
 * Se ci si trova in un endpoint "/osservazioni*" allora si tratta di una richiesta pubblica.
 * Altrimenti, si è nella pagina dedicata alle richieste dell'utente loggato.
 */
export function isPublicSubmission(path: string) {
  return path.includes('/osservazioni');
}
